import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import PersonIcon from "@mui/icons-material/Person";
import React, { type FC, useCallback } from "react";
import { useNavigate } from "react-router";

import { ROUTES } from "~/constants/routing";
import type { ISearchEntity } from "~/feature/search/type";
import { convertSearchEntitySlug } from "~/utils/searchEntitySlug";

import * as Styled from "./SearchEntityBlock.styles";

interface ISearchEntityBlockProps {
  entity: ISearchEntity;
  onNavigate?: () => void;
}

export const SearchEntityBlock: FC<ISearchEntityBlockProps> = ({
  entity,
  onNavigate,
}) => {
  const navigate = useNavigate();

  const searchUrl = ROUTES.searchEntity.createURL(
    convertSearchEntitySlug(entity.searchQuery)
  );

  const handleMouseDown = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      onNavigate?.();
      navigate(searchUrl);
    },
    [navigate, searchUrl, onNavigate]
  );

  return (
    <Styled.EntityBlock onMouseDown={handleMouseDown}>
      {entity.image ? (
        <Styled.EntityImage src={entity.image} alt={entity.canonicalEntity} />
      ) : (
        <Styled.EntityImagePlaceholder>
          <PersonIcon fontSize="medium" color="disabled" />
        </Styled.EntityImagePlaceholder>
      )}

      <Styled.EntityInfo>
        <Styled.EntityTitle variant="body2">
          {entity.canonicalEntity} events
        </Styled.EntityTitle>
        <Styled.EntitySubtitle variant="caption">
          See all {entity.canonicalEntity}-related events
        </Styled.EntitySubtitle>
      </Styled.EntityInfo>

      <ArrowForwardIosIcon sx={{ fontSize: 12 }} color="disabled" />
    </Styled.EntityBlock>
  );
};
